import { render, staticRenderFns } from "./TwentySevenTable.vue?vue&type=template&id=237b30f4&"
import script from "./TwentySevenTable.vue?vue&type=script&lang=js&"
export * from "./TwentySevenTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports